import { createQueryClient } from "@jkast90/kast-common/query-client";
import { failFastOffline } from "@jkast90/kast-common/offline/query";
import { statusOf } from "./api";

// No subscribeToAuthErrors: the app has no 401 signal of its own. A query's
// 401 clears the cache, and so does the account changing (CacheScope).
export const queryClient = createQueryClient({ statusOf });

// Offline, a read fails at once with the OfflineError the page shows instead
// of waiting paused behind "Loading…" (TanStack's default), and isn't
// retried; a write fails rather than going out whenever the network is back.
// Reads still refetch on reconnect.
failFastOffline(queryClient);
